
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.ServiceTime = {

  template: () => {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              html: `${Monet.I18n.getResourcesByKey('event.servicetime.rule')}:`,
              attributes: {
                class: 'control-label',
                for: 'service_time_combo',
              },
            },
            {
              tag: 'select',
              items: [
                {
                  tag: 'option',
                  html: Monet.I18n.getResourcesByKey('event.servicetime.rule.percentual'),
                  attributes: {
                    'value': 'percentual',
                  },
                },
                {
                  tag: 'option',
                  html: Monet.I18n.getResourcesByKey('event.servicetime.rule.fixed'),
                  attributes: {
                    value: 'fixed',
                  },
                },
              ],
              attributes: {
                id: 'service_time_combo',
              },
            },
            {
              tag: 'label',
              html: ':',
              attributes: {
                id: 'service_time_param_label',
                class: 'control-label',
                for: 'service_time_param',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'text',
                    name: 'service_time_param',
                    'maxlength': '10',
                    'alt': '',
                    value: '',
                    'size': '11',
                    'id': 'service_time_param',
                    'class': 'modelAttribute textField numberPicker mandatory',
                    'autocomplete': 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },
  assignParameter : (jsonParam) => {

    const setParamLabel = (selection) => {
      const label = $('#service_time_param_label');
      const resource = `event.servicetime.${selection}`;
      const text = Monet.I18n.getResourcesByKey(resource);
      label.text(`${text}:`);
    }

    const combo = $('#service_time_combo');
    const field = $('#service_time_param');
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      if (jsonParam.percentualVar) {
        combo.val('percentual');
        field.val(jsonParam.percentualVar);
      } else if (jsonParam.minutesVar) {
        combo.val('fixed');
        field.val(jsonParam.minutesVar);
      }
    }
    setParamLabel(combo.val());
    combo.on('change', () => {
      setParamLabel(combo.val());
    });
  },

  retrieveParameter : () => {
    let value = $('#service_time_param').val();
    value = parseInt(value, 10);

    const combo = $('#service_time_combo');
    switch (combo.val()) {
      case 'fixed':
        return JSON.stringify({ minutesVar: value });
      case 'percentual':
        return JSON.stringify({ percentualVar: value });
      default:
        console.log("Greenmile.Event.EventCheck in retrieveParameter don't have a default parameter");
        break;
    }
  }
};
